export const UNUSED_ACTION_TYPE = Symbol('UNUSED_ACTION_TYPE');
